// Spec 078 US5 — links de exibição de uma linha (GESTOR). Invalidação explícita por mutação
// (tabela em invalidacao-de-cache.mdx): gerar e revogar invalidam ["display-tokens", lineId].
import { useMutation, useQuery, useQueryClient, type UseQueryResult } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type {
  CreateDisplayTokenRequest,
  CreateDisplayTokenResponse,
  DisplayTokenSummary,
} from "@/types/display-tokens.types";

export const displayTokensKey = (lineId: string) => ["display-tokens", lineId] as const;

export function useDisplayTokens(
  lineId: string,
  enabled = true
): UseQueryResult<DisplayTokenSummary[]> {
  return useQuery({
    queryKey: displayTokensKey(lineId),
    queryFn: () => api.get<DisplayTokenSummary[]>(`/api/v1/lines/${lineId}/display-tokens`),
    enabled: enabled && lineId.length > 0,
  });
}

export function useCreateDisplayToken(lineId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateDisplayTokenRequest) =>
      api.post<CreateDisplayTokenResponse>(`/api/v1/lines/${lineId}/display-tokens`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: displayTokensKey(lineId) }),
    meta: { skipErrorToast: true },
  });
}

export function useRevokeDisplayToken(lineId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (tokenId: string) =>
      api.delete<DisplayTokenSummary>(`/api/v1/lines/${lineId}/display-tokens/${tokenId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: displayTokensKey(lineId) }),
  });
}
